<template>
  <note-form
    :initDocumentation="initDocumentation"
    :successMsg="t('created')"
    :submitAction="submit"
  />
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import NoteForm from '@/views/customers/notes/NoteForm.vue'
import Documentation from '@/models/customer/Documentation'
import {useI18n} from 'vue-i18n'

export default defineComponent({
  name: 'new-note',

  setup() {
    const {t} = useI18n({
      messages: {
        en: {
          created: 'Note was created successfully'
        },
        ar: {
          created: 'تم انشاء الملاحظة بنجاح'
        }
      }
    })

    return {t}
  },

  components: {
    NoteForm
  },

  data() {
    return {
      initDocumentation: new Documentation(),
    }
  },

  async mounted() {
    if (this.$route.query.customer_id) {
      try {
        const customer = await this.$http.get<any>(
          `/customer/customers/${this.$route.query.customer_id}`
        )
        this.initDocumentation.customerID = customer.id
        this.initDocumentation.name = customer.name || ''
        this.initDocumentation.phone = customer.phone || ''
      } catch (e) {
        console.log(e)
      }
    }
  },

  methods: {
    async submit(documentation: Documentation, pin?: string) {
      try {
        const headers: Record<string, string> = {}
        if (pin) headers.pin = pin
        await this.$http.post(Documentation.ENDPOINT, documentation, { headers })
        this.$router.back()
      } catch (error) {
        return error
      }
    }
  }
})
</script>
